// 载荷设置
export default {
    loadSetting: 'Настройка загрузки',
    thrower: 'Сбрасыватель',
    searchlight: 'Прожектор',
    pager: 'Звонок',
    descentRetarder: 'Буфер',
    loadType: 'Тип {0}',
    hangPoint: 'Вешай.',
    color: 'Цвет',
    default: 'По умолчанию',
    blue: 'Синий',
    yellow: 'Жёлтый',
    grey: 'Серый',
    purple: 'Пурпурный',
    name: 'Имя',
    addPlaylist: 'Добавить в список воспроизведения',
    device: 'Оборудование',
    PTZCamera: 'Облачная камера',
    directShouting: 'Прямой крик',
    audioPlayback: 'Звуковое воспроизведение',
    playlist: 'Список воспроизведения',
    previousSong: 'Предыдущая песня',
    next: 'Следующая песня',
    implement: 'Осуществление',
    stop: 'Остановить',
    singlesPlaying: 'Синглы',
    singleTuneCirculation: 'Сингл - цикл',
    sequentialPlay: 'Последовательное воспроизведение',
    listLoop: 'Цикл списка',
    loopPlayback: 'Цикл воспроизведения',
    open: 'Открыть',
    close: 'Закрыть',
    meanwhile: 'Одновременно',
    successively: 'По очереди',
    interval: 'Интервал',
    abnormalCommunication: 'ненормальная связь',
    stow: 'Убрать',
    putDown: 'Опусти',
    PTZLoad: 'облачная нагрузка',
    PTZSetting: 'Настройка облачной платформы',
    camera: 'Камера',
    PTZManufacturer: 'Облачные производители',
    PTZType: 'Облачная модель',
    PTZModel: 'Облачный режим',
    courseLock: 'Курсовая блокировка',
    followMode: 'Режим следования',
    centerCross: 'Центральный крест',
    style: 'Стиль {0}',
    PTZCalibration: 'калибровка облачной платформы',
    startCalibration: 'Начинаем калибровку',
    imagingMode: 'Режим изображения',
    videoQuality: 'Качество видео',
    electronicAntiShake: 'Электронная защита от тряски',
    infraredStyle: 'Инфракрасный стиль',
    day: 'День',
    night: 'Ночь',
    ordinary: 'Обычные',
    difference: 'Б',
    extremelyLow: 'Очень низкий',
    low: 'Низкий',
    secondary: 'Средний',
    high: 'Высокий',
    veryHigh: 'Очень высоко',
    turnOffAntiShake: 'Отключить дрожание',
    enableElectronicAntiShake: 'Включите электрон против дрожания',
    turnOnOpticalAntiShake: 'Включите оптическую защиту от дрожания',
    blackFever: 'Чёрная лихорадка',
    whiteFever: 'Белая лихорадка',
    ferruginousRed: 'Красный',
    rainbow: 'Радуга',
    lava: 'Лава',
    rainbowEnhancement: 'Радуга усиливается',
    moltenMetal: 'Плавленный металл',
    bluishRed: 'Сине - красный',
    amber: 'Амбер',
    tip_err1: 'Ошибка формата звука, пожалуйста, загрузите его снова!',
    tip_err2: 'Размер звука не должен превышать 10 Мб!',
    tip_err3: 'Имя файла до 10 символов, пожалуйста, измените и загрузите снова!',
    tip_err4: 'Выберите звук, который нужно воспроизвести',
    tip_err5: 'Имя файла может содержать только китайские, английские и цифровые!',
}